<template id="client">
  <div class="col-md-3 col-sm-3 col-xs-6">
    <div class="brandItems">
      <div class="clientIcons"><img :src="getImage(this.client)" alt="#"></div>
      <div class="clientInfo">
        <div class="clientInfoText"><a :n="this.client.name" v-html="this.client.name"></a></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'client',
  props:['client'],
  data () {
    return {
    }
  },
  components: {
  },
  methods: {
    getImage:function(c) {
      if (c.image) return c.image;
      return 'images/brand-items' + (c.id<10?'0':'') + c.id+'.png';
    }
  },
  mounted: function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Client.vue